const obj = {
  id: '',
  nome: '',
  email: '',
  dataRegistro: '',
  tituloProgramacao: '',
}

export default function CheckinReportModel(params = obj) {
  return { ...obj, ...params, };
};
